export default {
  loading: false,
  isSuccess: false,
  loginAccount: {},
  menuList: []
};
